import { Component } from '@angular/core';
import { PopupModalService } from '../../services/popup-modal.service';

@Component({
    selector: 'app-pop-up-modal',
    styleUrls: ['popup-modal.scss'],
    templateUrl: './popup-modal.component.html'
})

export class PopupModalComponent {
    constructor(public popupModelService : PopupModalService) { }
}
